export const numberAsCurrency = number => {
    // Special handling for $2,000,000+ option (using 2500000 as the value)
    if (number === 2500000 || number === "2500000") {
        return "$2,000,000+";
    }
    return "$" + number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};